// Training Test Questions - Bilingual (English/Portuguese)
export const questions = [
    // CLEANING PRODUCTS SECTION (8 questions)
    {
        id: 1,
        question: {
            en: "Where should corrosive products be stored?",
            pt: "Onde os produtos corrosivos devem ser armazenados?"
        },
        options: {
            en: [
                "On the car floor",
                "Inside the cleaning bucket",
                "In any bag or container",
                "Loose in the trunk"
            ],
            pt: [
                "No chão do carro",
                "Dentro do balde de limpeza",
                "Em qualquer bolsa ou recipiente",
                "Soltos no porta-malas"
            ]
        },
        correct: 1,
        category: "products"
    },
    {
        id: 2,
        question: {
            en: "Which surfaces should you NEVER use bleach on?",
            pt: "Em quais superfícies você NUNCA deve usar água sanitária?"
        },
        options: {
            en: [
                "White porcelain sinks and tempered glass",
                "Colored walls and marble/natural stone",
                "Ceramic tiles and grout",
                "Frameless glass/windows"
            ],
            pt: [
                "Pias brancas de louça e vidro temperado",
                "Paredes coloridas e mármore/pedra natural",
                "Azulejos cerâmicos e rejunte",
                "Vidros/janelas sem moldura"
            ]
        },
        correct: 1,
        category: "products"
    },
    {
        id: 3,
        question: {
            en: "What is the main concern when using Jif Cream (Cif)?",
            pt: "Qual é a principal preocupação ao usar Jif Cream (Cif)?"
        },
        options: {
            en: [
                "It has a very strong odor",
                "It's toxic and requires a mask",
                "It's mildly abrasive and can scratch aluminum and painted wood",
                "It must be diluted before use"
            ],
            pt: [
                "Tem um odor muito forte",
                "É tóxico e requer máscara",
                "É levemente abrasivo e pode arranhar alumínio e madeira pintada",
                "Deve ser diluído antes do uso"
            ]
        },
        correct: 2,
        category: "products"
    },
    {
        id: 4,
        question: {
            en: "What should NEVER be mixed with neutral detergent (soap)?",
            pt: "O que NUNCA deve ser misturado com detergente neutro (sabão)?"
        },
        options: {
            en: [
                "Warm water",
                "Disinfectant or bleach",
                "Glass cleaner",
                "Floor cleaner"
            ],
            pt: [
                "Água morna",
                "Desinfetante ou água sanitária",
                "Limpador de vidros",
                "Limpador de pisos"
            ]
        },
        correct: 1,
        category: "products"
    },
    {
        id: 5,
        question: {
            en: "How should glass cleaner be applied?",
            pt: "Como o limpador de vidros deve ser aplicado?"
        },
        options: {
            en: [
                "Spray directly on the glass",
                "Mix with water first",
                "Spray on microfiber cloth, not directly on glass",
                "Apply with a sponge"
            ],
            pt: [
                "Pulverize diretamente no vidro",
                "Misture com água primeiro",
                "Pulverize no pano de microfibra, não diretamente no vidro",
                "Aplique com uma esponja"
            ]
        },
        correct: 2,
        category: "products"
    },
    {
        id: 6,
        question: {
            en: "Where should oven racks NEVER be left?",
            pt: "Onde as grades do forno NUNCA devem ser deixadas?"
        },
        options: {
            en: [
                "In the oven",
                "On benches or surfaces that can stain",
                "In the sink",
                "Outside to dry"
            ],
            pt: [
                "No forno",
                "Em bancadas ou superfícies que possam manchar",
                "Na pia",
                "Do lado de fora para secar"
            ]
        },
        correct: 1,
        category: "products"
    },
    {
        id: 7,
        question: {
            en: "What should you avoid adding to floor cleaner solution?",
            pt: "O que você deve evitar adicionar à solução de limpador de pisos?"
        },
        options: {
            en: [
                "Warm water",
                "Inappropriate products or excessive floor cleaner",
                "Clean water",
                "Soap"
            ],
            pt: [
                "Água morna",
                "Produtos inadequados ou excesso de limpador de piso",
                "Água limpa",
                "Sabão"
            ]
        },
        correct: 1,
        category: "products"
    },
    {
        id: 8,
        question: {
            en: "Where should multipurpose cleaner be used?",
            pt: "Onde o limpador multiuso deve ser usado?"
        },
        options: {
            en: [
                "Only on glass and mirrors",
                "Only on floors",
                "On furniture, walls, doors, switches, and toilets",
                "Only on kitchen surfaces"
            ],
            pt: [
                "Apenas em vidros e espelhos",
                "Apenas em pisos",
                "Em móveis, paredes, portas, interruptores e vasos sanitários",
                "Apenas em superfícies de cozinha"
            ]
        },
        correct: 2,
        category: "products"
    },

    // SAFETY PROCEDURES (7 questions)
    {
        id: 9,
        question: {
            en: "What is the correct posture for lifting objects?",
            pt: "Qual é a postura correta para levantar objetos?"
        },
        options: {
            en: [
                "Keep legs straight and bend your back",
                "Bend knees, keep back straight, hold items close to body",
                "Use only your arms to lift",
                "Bend sideways to pick up objects"
            ],
            pt: [
                "Mantenha as pernas retas e dobre as costas",
                "Dobre os joelhos, mantenha as costas retas, segure os itens perto do corpo",
                "Use apenas os braços para levantar",
                "Dobre-se de lado para pegar objetos"
            ]
        },
        correct: 1,
        category: "safety"
    },
    {
        id: 10,
        question: {
            en: "What care should be taken when vacuuming near walls and skirting boards?",
            pt: "Que cuidado deve ser tomado ao aspirar perto de paredes e rodapés?"
        },
        options: {
            en: [
                "Vacuum as fast as possible",
                "Press hard against them for better cleaning",
                "Move carefully to avoid marks or damage; control the distance",
                "Don't vacuum near walls at all"
            ],
            pt: [
                "Aspire o mais rápido possível",
                "Pressione com força contra eles para uma melhor limpeza",
                "Mova com cuidado para evitar marcas ou danos; controle a distância",
                "Não aspire perto de paredes"
            ]
        },
        correct: 2,
        category: "safety"
    },
    {
        id: 11,
        question: {
            en: "If a task feels unsafe, what should you do?",
            pt: "Se uma tarefa parecer insegura, o que você deve fazer?"
        },
        options: {
            en: [
                "Continue but work more carefully",
                "Stop and inform the Team Leader or Michel immediately",
                "Ask a coworker to do it",
                "Skip that task entirely"
            ],
            pt: [
                "Continue, mas trabalhe com mais cuidado",
                "Pare e informe o Líder da Equipe ou Michel imediatamente",
                "Peça a um colega para fazer",
                "Pule essa tarefa inteiramente"
            ]
        },
        correct: 1,
        category: "safety"
    },
    {
        id: 12,
        question: {
            en: "When should you wear a mask and goggles?",
            pt: "Quando você deve usar máscara e óculos?"
        },
        options: {
            en: [
                "Only when cleaning bathrooms",
                "When ventilation is poor or splash risk exists",
                "Never required",
                "Only on Fridays"
            ],
            pt: [
                "Apenas ao limpar banheiros",
                "Quando a ventilação é ruim ou existe risco de respingos",
                "Nunca é necessário",
                "Apenas às sextas-feiras"
            ]
        },
        correct: 1,
        category: "safety"
    },
    {
        id: 13,
        question: {
            en: "What should you do if you see a potential hazard in the work area?",
            pt: "O que você deve fazer se ver um perigo em potencial na área de trabalho?"
        },
        options: {
            en: [
                "Report to the Team Leader or Michel as soon as you see it",
                "Wait until the end of the day",
                "Only report if someone gets hurt",
                "Clean it up yourself without telling anyone"
            ],
            pt: [
                "Relate para o Team Leader ou Michel assim que ver",
                "Aguarde até o final do dia",
                "Relate apenas se alguém se machucar",
                "Limpe você mesmo sem contar a ninguém"
            ]
        },
        correct: 0,
        category: "safety"
    },
    {
        id: 14,
        question: {
            en: "When must incidents be recorded?",
            pt: "Quando os incidentes devem ser registrados?"
        },
        options: {
            en: [
                "Within one week",
                "Only when serious",
                "On the same day, even if minor",
                "Only if there is an injury"
            ],
            pt: [
                "Dentro de uma semana",
                "Somente quando for grave",
                "No mesmo dia, mesmo que seja menor",
                "Somente se houver lesão"
            ]
        },
        correct: 2,
        category: "safety"
    },
    {
        id: 15,
        question: {
            en: "How should light objects be moved?",
            pt: "Como os objetos leves devem ser movidos?"
        },
        options: {
            en: [
                "Quickly to save time",
                "Handle with both hands and move carefully",
                "Push or drag them",
                "Ask the client to move them"
            ],
            pt: [
                "Rapidamente para economizar tempo",
                "Manuseie com ambas as mãos e mova com cuidado",
                "Empurre ou arraste-os",
                "Peça ao cliente para movê-los"
            ]
        },
        correct: 1,
        category: "safety"
    },

    // EQUIPMENT USAGE (6 questions)
    {
        id: 16,
        question: {
            en: "Which side of the sponge should NEVER be used on cooktops, stainless steel, or glass?",
            pt: "Qual lado da esponja NUNCA deve ser usado em fogões, aço inoxidável ou vidro?"
        },
        options: {
            en: [
                "Yellow side",
                "Green side",
                "White side",
                "Either side is fine"
            ],
            pt: [
                "Lado amarelo",
                "Lado verde",
                "Lado branco",
                "Qualquer lado está bem"
            ]
        },
        correct: 1,
        category: "equipment"
    },
    {
        id: 17,
        question: {
            en: "What is the correct movement pattern when mopping?",
            pt: "Qual é o padrão de movimento correto ao esfregar com mop?"
        },
        options: {
            en: [
                "Circular motion",
                "Up and down only",
                "S-pattern to cover evenly",
                "Random movements"
            ],
            pt: [
                "Movimento circular",
                "Apenas para cima e para baixo",
                "Padrão em S para cobrir uniformemente",
                "Movimentos aleatórios"
            ]
        },
        correct: 2,
        category: "equipment"
    },
    {
        id: 18,
        question: {
            en: "When using a ladder, how many points of contact should you maintain?",
            pt: "Ao usar uma escada, quantos pontos de contato você deve manter?"
        },
        options: {
            en: [
                "One point",
                "Two points",
                "Three points",
                "Four points"
            ],
            pt: [
                "Um ponto",
                "Dois pontos",
                "Três pontos",
                "Quatro pontos"
            ]
        },
        correct: 2,
        category: "equipment"
    },
    {
        id: 19,
        question: {
            en: "Which step of the ladder is forbidden to step on?",
            pt: "Qual degrau da escada é proibido pisar?"
        },
        options: {
            en: [
                "The first step",
                "The second step",
                "The middle steps",
                "The top cap"
            ],
            pt: [
                "O primeiro degrau",
                "O segundo degrau",
                "Os degraus do meio",
                "A tampa superior"
            ]
        },
        correct: 3,
        category: "equipment"
    },
    {
        id: 20,
        question: {
            en: "Where should you avoid using ladders due to potential damage?",
            pt: "Onde você deve evitar usar escadas devido a possíveis danos?"
        },
        options: {
            en: [
                "On carpet",
                "On concrete floors",
                "On acrylic showers or fragile surfaces",
                "On tile floors"
            ],
            pt: [
                "Em carpete",
                "Em pisos de concreto",
                "Em boxes de acrílico ou superfícies frágeis",
                "Em pisos de azulejo"
            ]
        },
        correct: 2,
        category: "equipment"
    },
    {
        id: 21,
        question: {
            en: "What should you do with vacuum cords during use?",
            pt: "O que você deve fazer com os cabos do aspirador durante o uso?"
        },
        options: {
            en: [
                "Pull them around furniture quickly",
                "Keep them untangled and without tension; never pull around fragile objects",
                "Wrap them around your waist",
                "Leave them loose on the floor"
            ],
            pt: [
                "Puxe-os ao redor dos móveis rapidamente",
                "Mantenha-os desembaraçados e sem tensão; nunca puxe ao redor de objetos frágeis",
                "Enrole-os ao redor da cintura",
                "Deixe-os soltos no chão"
            ]
        },
        correct: 1,
        category: "equipment"
    },

    // COMPANY RULES (6 questions)
    {
        id: 22,
        question: {
            en: "What is the acceptable delay time for a service with a previously estimated time?",
            pt: "Qual é o tempo aceitável para atrasar em um serviço com tempo estimado anteriormente?"
        },
        options: {
            en: [
                "5 minutes",
                "10 minutes",
                "15 minutes",
                "30 minutes"
            ],
            pt: [
                "5 minutos",
                "10 minutos",
                "15 minutos",
                "30 minutos"
            ]
        },
        correct: 1,
        category: "rules"
    },
    {
        id: 23,
        question: {
            en: "By when must the weekly closing be completed on our website?",
            pt: "Até quando o fechamento semanal deve ser feito no nosso site?"
        },
        options: {
            en: [
                "Monday 9 AM",
                "Friday 5 PM",
                "Sunday 5 PM",
                "Any time before payment"
            ],
            pt: [
                "Segunda-feira 9h",
                "Sexta-feira 17h",
                "Domingo 17h",
                "A qualquer momento antes do pagamento"
            ]
        },
        correct: 2,
        category: "rules"
    },
    {
        id: 24,
        question: {
            en: "What are the standard work hours?",
            pt: "Quais são os horários de trabalho padrão?"
        },
        options: {
            en: [
                "Monday to Friday, 7:00 AM to 4:00 PM",
                "Monday to Friday, 8:00 AM to 5:00 PM; weekends as needed",
                "Monday to Sunday, 8:00 AM to 5:00 PM",
                "Flexible hours"
            ],
            pt: [
                "Segunda a sexta, 7h às 16h",
                "Segunda a sexta, 8h às 17h; fins de semana conforme necessário",
                "Segunda a domingo, 8h às 17h",
                "Horários flexíveis"
            ]
        },
        correct: 1,
        category: "rules"
    },
    {
        id: 25,
        question: {
            en: "When should social media be checked during work?",
            pt: "Quando as redes sociais devem ser verificadas durante o trabalho?"
        },
        options: {
            en: [
                "Anytime if you're quick",
                "During travel time between houses or during break time",
                "During lunch only",
                "While cleaning"
            ],
            pt: [
                "A qualquer momento se você for rápido",
                "No trajeto de uma casa para outra ou na hora do intervalo",
                "Apenas durante o almoço",
                "Enquanto limpa"
            ]
        },
        correct: 1,
        category: "rules"
    },
    {
        id: 26,
        question: {
            en: "What should you do if you finish your work before your teammates?",
            pt: "O que você deve fazer se terminar seu trabalho antes dos seus colegas?"
        },
        options: {
            en: [
                "Wait in the car",
                "Check your phone",
                "Help with organizing supplies, assisting with vacuum/mop, cleaning windows or entry area",
                "Leave early"
            ],
            pt: [
                "Espere no carro",
                "Verifique seu telefone",
                "Ajude organizando suprimentos, auxiliando com aspirador/esfregão, limpando janelas ou área de entrada",
                "Saia mais cedo"
            ]
        },
        correct: 2,
        category: "rules"
    },
    {
        id: 27,
        question: {
            en: "For deep cleans, move-out cleans, or one-off cleans, what must you always do?",
            pt: "Para deep cleans, move-out cleans ou one-off cleans, o que você deve sempre fazer?"
        },
        options: {
            en: [
                "Finish as quickly as possible",
                "Before starting, check for any prior damage, and always take before and after photos",
                "Skip documentation",
                "Only take photos if something is damaged"
            ],
            pt: [
                "Termine o mais rápido possível",
                "Antes de começar verifique se não tem nenhum dano prévio, e sempre tirar fotos de antes e depois",
                "Pule a documentação",
                "Tire fotos apenas se algo estiver danificado"
            ]
        },
        correct: 1,
        category: "rules"
    },

    // PROFESSIONAL CONDUCT (4 questions)
    {
        id: 28,
        question: {
            en: "If a client has extra requests or a long list, what should you do?",
            pt: "Se um cliente tiver solicitações extras ou uma lista longa, o que você deve fazer?"
        },
        options: {
            en: [
                "Accept immediately to make the client happy",
                "Refuse all extra work",
                "Call the company to confirm before accepting",
                "Do half of what they ask"
            ],
            pt: [
                "Aceite imediatamente para deixar o cliente feliz",
                "Recuse todo trabalho extra",
                "Ligue para a empresa para confirmar antes de aceitar",
                "Faça metade do que eles pedem"
            ]
        },
        correct: 2,
        category: "conduct"
    },
    {
        id: 29,
        question: {
            en: "What should you do with lights when finishing?",
            pt: "O que você deve fazer com as luzes ao terminar?"
        },
        options: {
            en: [
                "Always turn them all off",
                "Always leave them all on",
                "Turn off when finishing unless they were already on",
                "Leave them on for safety"
            ],
            pt: [
                "Sempre desligue todas",
                "Sempre deixe todas ligadas",
                "Desligue ao terminar, a menos que já estivessem ligadas",
                "Deixe-as ligadas para segurança"
            ]
        },
        correct: 2,
        category: "conduct"
    },
    {
        id: 30,
        question: {
            en: "What should you do if you find damaged or pre-damaged items?",
            pt: "O que você deve fazer se encontrar itens danificados ou pré-danificados?"
        },
        options: {
            en: [
                "Ignore it and continue working",
                "Tell the client directly",
                "Photograph and report immediately",
                "Fix it yourself"
            ],
            pt: [
                "Ignore e continue trabalhando",
                "Diga ao cliente diretamente",
                "Fotografe e relate imediatamente",
                "Conserte você mesmo"
            ]
        },
        correct: 2,
        category: "conduct"
    }
];

// Question categories for reporting
export const categories = {
    en: {
        products: "Cleaning Products Usage",
        safety: "Safety Procedures",
        equipment: "Equipment Usage",
        rules: "Company Rules",
        conduct: "Professional Conduct"
    },
    pt: {
        products: "Uso de Produtos de Limpeza",
        safety: "Procedimentos de Segurança",
        equipment: "Uso de Equipamentos",
        rules: "Regras da Empresa",
        conduct: "Conduta Profissional"
    }
};
